'use client';

import type { ReactNode } from 'react';
import { Loader2, RefreshCw } from 'lucide-react';

export function OrganizerLoadingState({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="org-finance-loading py-16" role="status">
      <Loader2 className="h-8 w-8 animate-spin text-[var(--color-text-muted)]" />
      <p className="mt-3 text-sm text-[var(--color-text-muted)]">{label}</p>
    </div>
  );
}

export function OrganizerErrorState({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="org-account-alert org-account-alert--error flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <p className="text-sm m-0">{message}</p>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="org-finance-hero-btn org-finance-hero-btn--ghost !text-[var(--color-text)] !border-[var(--color-border)] !bg-bg shrink-0 inline-flex items-center gap-2"
        >
          <RefreshCw className="w-3.5 h-3.5" />
          Retry
        </button>
      ) : null}
    </div>
  );
}

export function OrganizerEmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="ow-empty py-14">
      <p className="ow-empty-title">{title}</p>
      {description ? <p className="ow-empty-text">{description}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
